module.exports = __webpack_public_path__ + "static/media/focus.e396db4a.svg";